import React, { useState } from "react";

interface GradientCardProps {
  header: React.ReactNode;
  description: React.ReactNode;
  colorFrom?: string;
  colorTo?: string;
}

const GradientCard: React.FC<GradientCardProps> = ({
  header,
  description,
  colorFrom = "#ff7a7a",
  colorTo = "#ff4f81",
}) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div
      className="relative w-full rounded-2xl overflow-hidden shadow-lg transition-all duration-300"
      style={{
        background: `linear-gradient(120deg, ${colorFrom}, ${colorTo})`,
        aspectRatio: expanded ? ("auto" as any) : "5 / 1",
      }}
    >
      {/* 3D overlay layers */}
      <div className="absolute inset-0">
        <div
          className="absolute bg-white/10 rotate-6 blur-xl"
          style={{
            top: "-20%",
            left: "10%",
            width: "80%",
            height: "140%",
            transform: "skewX(-15deg)",
          }}
        />
        <div
          className="absolute bg-black/5 rotate-[-10deg]"
          style={{
            bottom: "-10%",
            right: "-10%",
            width: "70%",
            height: "130%",
            transform: "skewX(20deg)",
          }}
        />
      </div>

      {/* Content */}
      <div className="relative h-full w-full text-white px-4 py-3">
        <div className="flex items-center justify-between">
          <span className="text-xl font-semibold drop-shadow-md">{header}</span>
          {description && (
            <button
              type="button"
              aria-label={expanded ? "Collapse details" : "Expand details"}
              aria-expanded={expanded}
              onClick={() => setExpanded((v) => !v)}
              className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/15 hover:bg-white/25 transition-colors focus:outline-none focus:ring-2 focus:ring-white/40"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="w-5 h-5 text-white"
              >
                {expanded ? (
                  <>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M7 17l5-5 5 5" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M7 11l5-5 5 5" />
                  </>
                ) : (
                  <>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M7 7l5 5 5-5" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M7 13l5 5 5-5" />
                  </>
                )}
              </svg>
            </button>
          )}
        </div>

        {expanded && description && (
          <div className="mt-2 text-sm leading-relaxed opacity-95 pr-8">
            {description}
          </div>
        )}
      </div>
    </div>
  );
};

export default GradientCard;
